//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './HL7TemplateRulesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetHL7TemplateRulesQueryParameters = {
  subtenantId?: number | null | undefined ;
  isActive?: boolean | null | undefined ;
  messageGroup?: Types.HL7MessageGroup | null | undefined ;
  dataBlockTypeId?: number | null | undefined ;
}

export type GetSingleHL7TemplateRulesQueryParameters = {
  id: number ;
}

export type PatchHL7TemplateRulesQueryParameters = {
  id: number ;
}

export type RemoveHL7TemplateRulesQueryParameters = {
  id: number ;
}

export function getUrl(subtenantId?: number | null | undefined, isActive?: boolean | null | undefined, messageGroup?: Types.HL7MessageGroup | null | undefined, dataBlockTypeId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/hl7/template-rules?";
if (subtenantId !== undefined && subtenantId !== null)
    url_ += "SubtenantId=" + encodeURIComponent("" + subtenantId) + "&";
if (isActive !== undefined && isActive !== null)
    url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
if (messageGroup !== undefined && messageGroup !== null)
    url_ += "MessageGroup=" + encodeURIComponent("" + messageGroup) + "&";
if (dataBlockTypeId !== undefined && dataBlockTypeId !== null)
    url_ += "DataBlockTypeId=" + encodeURIComponent("" + dataBlockTypeId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.HL7TemplateRuleDto[], unknown, Types.HL7TemplateRuleDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7TemplateRuleDto[], unknown, Types.HL7TemplateRuleDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetHL7TemplateRulesQueryParameters): QueryKey;
export function getQueryKey(subtenantId?: number | null | undefined, isActive?: boolean | null | undefined, messageGroup?: Types.HL7MessageGroup | null | undefined, dataBlockTypeId?: number | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantId, isActive, messageGroup, dataBlockTypeId,  } = params[0] as GetHL7TemplateRulesQueryParameters;

    return trimArrayEnd([
        'HL7TemplateRulesClient',
        'get',
        subtenantId as any,
        isActive as any,
        messageGroup as any,
        dataBlockTypeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'HL7TemplateRulesClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as boolean | null | undefined,       context.queryKey[4] as Types.HL7MessageGroup | null | undefined,       context.queryKey[5] as number | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.HL7TemplateRuleDto[], TError = unknown>(dto: GetHL7TemplateRulesQueryParameters, options?: Omit<UseQueryOptions<Types.HL7TemplateRuleDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets HL7 template rules.
 * @param subtenantId (optional) 
 * @param isActive (optional) 
 * @param messageGroup (optional) 
 * @param dataBlockTypeId (optional) 
 */
export function useGetQuery<TSelectData = Types.HL7TemplateRuleDto[], TError = unknown>(subtenantId?: number | null | undefined, isActive?: boolean | null | undefined, messageGroup?: Types.HL7MessageGroup | null | undefined, dataBlockTypeId?: number | null | undefined, options?: Omit<UseQueryOptions<Types.HL7TemplateRuleDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.HL7TemplateRuleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7TemplateRuleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantId: any = undefined;
  let isActive: any = undefined;
  let messageGroup: any = undefined;
  let dataBlockTypeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantId, isActive, messageGroup, dataBlockTypeId,  } = params[0] as GetHL7TemplateRulesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantId, isActive, messageGroup, dataBlockTypeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7TemplateRuleDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(subtenantId, isActive, messageGroup, dataBlockTypeId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7TemplateRuleDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets HL7 template rules.
 * @param subtenantId (optional) 
 * @param isActive (optional) 
 * @param messageGroup (optional) 
 * @param dataBlockTypeId (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.HL7TemplateRuleDto[] | undefined) => Types.HL7TemplateRuleDto[], subtenantId?: number | null | undefined, isActive?: boolean | null | undefined, messageGroup?: Types.HL7MessageGroup | null | undefined, dataBlockTypeId?: number | null | undefined) {
  queryClient.setQueryData(getQueryKey(subtenantId, isActive, messageGroup, dataBlockTypeId),
    updater
  );
}

/**
 * Gets HL7 template rules.
 * @param subtenantId (optional) 
 * @param isActive (optional) 
 * @param messageGroup (optional) 
 * @param dataBlockTypeId (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7TemplateRuleDto[] | undefined) => Types.HL7TemplateRuleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/template-rules";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'HL7TemplateRulesClient',
      'create',
    ]);
}

/**
 * Creates a HL7 template rule.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.HL7TemplateRuleDto, unknown, Types.CreateHL7TemplateRuleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.HL7TemplateRuleDto, unknown, Types.CreateHL7TemplateRuleDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateHL7TemplateRuleDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.HL7TemplateRuleDto, unknown, Types.HL7TemplateRuleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7TemplateRuleDto, unknown, Types.HL7TemplateRuleDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleHL7TemplateRulesQueryParameters;

    return trimArrayEnd([
        'HL7TemplateRulesClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'HL7TemplateRulesClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.HL7TemplateRuleDto, TError = unknown>(dto: GetSingleHL7TemplateRulesQueryParameters, options?: Omit<UseQueryOptions<Types.HL7TemplateRuleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets HL7 template rule by id.
 */
export function useGetSingleQuery<TSelectData = Types.HL7TemplateRuleDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.HL7TemplateRuleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.HL7TemplateRuleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7TemplateRuleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleHL7TemplateRulesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7TemplateRuleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7TemplateRuleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets HL7 template rule by id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.HL7TemplateRuleDto | undefined) => Types.HL7TemplateRuleDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets HL7 template rule by id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7TemplateRuleDto | undefined) => Types.HL7TemplateRuleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7TemplateRulesClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a hl7 template rule.
 * @param id The hl7 template rule id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchHL7TemplateRuleDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchHL7TemplateRuleDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchHL7TemplateRuleDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchHL7TemplateRulesQueryParameters & {
  dto: Types.PatchHL7TemplateRuleDto;
}

/**
 * Edits a hl7 template rule.
 * @param id The hl7 template rule id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchHL7TemplateRulesQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/template-rules/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7TemplateRulesClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a HL7 template rule.
 * @param id The hl7 template rule id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveHL7TemplateRulesQueryParameters

/**
 * Removes a HL7 template rule.
 * @param id The hl7 template rule id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveHL7TemplateRulesQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}